import { render, staticRenderFns } from "./ConsumersDistributionCard.vue?vue&type=template&id=0afce17f&scoped=true"
import script from "./ConsumersDistributionCard.vue?vue&type=script&lang=js"
export * from "./ConsumersDistributionCard.vue?vue&type=script&lang=js"
import style0 from "./ConsumersDistributionCard.vue?vue&type=style&index=0&id=0afce17f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0afce17f",
  null
  
)

export default component.exports